import { render, staticRenderFns } from "./CompraDiretaLegadaDetalhesCapa.vue?vue&type=template&id=2c3cf68e&scoped=true"
import script from "./CompraDiretaLegadaDetalhesCapa.vue?vue&type=script&lang=js"
export * from "./CompraDiretaLegadaDetalhesCapa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3cf68e",
  null
  
)

export default component.exports